import { FC } from "react";
// API
import { GetActivityTemplates_activityTemplates } from "api/MyLivestock/Activity/types/GetActivityTemplates";
// Utils
import { useGetActivityTemplates } from "hooks";
// Components
import { Button, Flex, Spacer } from "components";
import { WizardOptions } from "import/components/WizardOptions";

interface ImportWizardChooseTemplateProps {
  activityTypeId: string;
  onClickBack: () => void;
  onSelect: (activityId: GetActivityTemplates_activityTemplates) => void;
}

export const ImportWizardChooseTemplate: FC<ImportWizardChooseTemplateProps> = ({
  activityTypeId,
  onClickBack,
  onSelect,
}) => {
  const { data: activityTemplates } = useGetActivityTemplates();
  const activityTemplatesForType = activityTemplates.filter(
    (activityTemplate) => activityTemplate.activityType?.id === activityTypeId,
  );

  return (
    <>
      <WizardOptions>
        {activityTemplatesForType.map((activityTemplate) => {
          const handleClick = () => onSelect(activityTemplate);

          return <WizardOptions.Option key={activityTemplate.id} name={activityTemplate.name} onClick={handleClick} />;
        })}
      </WizardOptions>

      <Spacer baselineHeight={4} />

      <Flex container containerJustifyContent="space-between">
        <Button caption="Back" colour="grey" onClick={onClickBack} variant="hollow" />
      </Flex>
    </>
  );
};
